import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { isUserAdmin } from '../helpers/adminAuth';
import './AdminPage.css';

/**
 * Admin Hub Page - Central gateway for API Hub administration and observability
 * Displays key metrics and provides navigation to detailed admin features
 */
const AdminPage: React.FC = () => {
  const navigate = useNavigate();
  const { authState } = useOktaAuth();

  const handleNavigateToReports = () => {
    navigate('/admin/reports');
  };

  if (authState?.isPending) {
    return <div className="container mt-4"><div className="loading">Verifying permissions...</div></div>;
  }

  if (!isUserAdmin(authState)) {
    return (
      <div className="container mt-4">
        <div className="alert alert-error">
          <h4>Access Denied</h4>
          <p>You do not have permission to access the Administration page. Only admins can view this section.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-header-container">
      <div className="admin-header">
        <h1>Administration</h1>
        <p className="subtitle">Observability, Compliance & Governance</p>
      </div>
      <div className="admin-content-container">
        <button type="button" className="action-card" onClick={handleNavigateToReports}>
          <div className="card-title">API Reports</div>
          <div className="card-description">
            View detailed compliance reports for all APIs. Filter by team, area, and compliance status.
          </div>
          <div className="card-action">View Reports →</div>
        </button>
      </div>
    </div>
  );
};

export default AdminPage;